import {Settings} from "~/app/core/model/settings";
import {inject} from "@angular/core";
import {CoreService} from "~/app/core/core.service";

export abstract class BasePage {
    waiting: boolean = false;
    waitingSpinning: boolean = true;
    allowBack: boolean = false;

    private coreService = inject(CoreService);

    constructor() {
    }

    get settings(): Settings {
        return this.coreService.api.device_loadSettings();
    }
}
